import * as IApiKlucComponents from "./components/IApiKlucComponents";
import * as IUzComponents from "./components/IUzComponents"

/**
 * Meta component factory
 * @param {*} customComponentFactory 
 * @param {*} primaryField 
 * @param {*} field 
 * @param {*} value 
 * @param {*} onChange 
 * @param {*} obj 
 * @returns 
 */
const componentFactory = (customComponentFactory, primaryField, field, value, onChange, obj) => {
  try {
    const customComponent = customComponentFactory ? customComponentFactory(primaryField, field, value, onChange, obj) : null;
    if (customComponent) return customComponent;

    switch (primaryField) {
      case "IApiKluc":
        return IApiKlucComponents[field.customComponent](value, onChange, obj);
      case "IUz":
        return IUzComponents[field.customComponent](value, onChange, obj);
      default:
        break;
    }
  } catch (error) {
    console.log("Meta component factory - components loading failed");
  }
  return null;
}

export default componentFactory;